module.exports = __webpack_public_path__ + "media/images/front/brands/avant_garde/avant_garde_3-e1fa180d9d2383d7c33536c991df92db.webp";